/** Welcome 弹窗支持的关闭原因。 */
export type HomeV2WelcomeCloseReason = 'auto' | 'cta' | 'dismiss';

/** Welcome 弹窗展示所需的动态文案。 */
export interface HomeV2WelcomeShowOptions {
    /** 弹窗标题。 */
    title: string;
    /** 产品能力说明。 */
    description: string;
    /** 主操作按钮文案。 */
    cta: string;
    /** 免费权益说明。 */
    benefit: string;
}

/** 单次 Welcome 弹窗的生命周期句柄。 */
export interface HomeV2WelcomeHandle {
    /** 用户或程序首次结束弹窗时返回的原因。 */
    result: Promise<HomeV2WelcomeCloseReason>;
    /** 以指定原因幂等关闭弹窗。 */
    close: (reason: HomeV2WelcomeCloseReason) => void;
    /** 幂等卸载弹窗及其宿主；待决结果以 dismiss 完成。 */
    dispose: () => void;
}

/** Home V2 Welcome 弹窗展示器。 */
export interface HomeV2WelcomePresenter {
    /**
     * 将 Welcome 弹窗挂载到页面顶层。
     * @param options 当前语言下的展示文案。
     * @returns 可等待关闭结果并完整清理的句柄。
     */
    show(options: HomeV2WelcomeShowOptions): HomeV2WelcomeHandle;
}

/** Home V2 Welcome 弹窗展示器的容器标识。 */
export const HomeV2WelcomePresenter = Symbol('HomeV2WelcomePresenter');
